import { DynamicColumnLayoutWebComponent } from './component/DynamicColumnLayoutWebComponent';
import { WEB_COMPONENT_LAYOUT } from '../../../webcomponents.constants';

export { DynamicColumnLayoutWebComponent };

window.customElements.define(WEB_COMPONENT_LAYOUT, DynamicColumnLayoutWebComponent);
